import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
const initialState = {
    selectedSolutionId: '',
    selectedType: 'wall',
    activeTab: 'PARAMETERS',
    expandedPanel: 'wall'
};
export const useValidationUiStore = create()(devtools(set => (Object.assign(Object.assign({}, initialState), { selectSolution: (solutionId, type) => set({ selectedSolutionId: solutionId, selectedType: type, expandedPanel: type }), setActiveTab: tab => set({ activeTab: tab }), setExpandedPanel: panel => set({ expandedPanel: panel }), reset: () => set(initialState) }))));
